var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption",style:({ marginBottom: _vm.marginBottom })},[_c('p',{staticClass:"left-cloud cloud"}),_vm._t("default"),_c('p',{staticClass:"right-cloud cloud"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }